import React from 'react';

import AudioPlayer from '@experiment-management-shared/components/AudioPlayer';
import { AudioAssetData } from '@experiment-management-shared/types';
import styles from './AudioDetail.module.scss';

export const AudioDetail = ({ asset }: { asset: AudioAssetData }) => {
  return (
    <div className={styles.container}>
      <AudioPlayer src={asset.userFileName} height={150} isFullScreen={true} />
    </div>
  );
};
